import { m } from 'framer-motion';
import { forwardRef } from 'react';

// Botao com icone e animacao framer-motion. Substitui MUI IconButton com
// variantes de escala on hover/tap baseadas no size. Aceita sx para
// compatibilidade com chamadores legados - opcoes ignoradas sao silenciosas.

const IconButtonAnimate = forwardRef(({ children, size = 'medium', sx, ...other }, ref) => (
  <AnimateWrap size={size}>
    <button
      ref={ref}
      type="button"
      className="inline-flex items-center justify-center rounded-full border-none bg-transparent p-0 text-current transition-colors hover:bg-soft disabled:opacity-50 disabled:cursor-not-allowed"
      {...other}
    >
      {children}
    </button>
  </AnimateWrap>
));

IconButtonAnimate.displayName = 'IconButtonAnimate';

export default IconButtonAnimate;

// Variacoes de escala por tamanho, aplicadas em hover/tap via framer-motion.
// Padrao: medium (escala 1.09).
const varSmall = {
  hover: { scale: 1.1 },
  tap: { scale: 0.95 },
};

const varMedium = {
  hover: { scale: 1.09 },
  tap: { scale: 0.97 },
};

const varLarge = {
  hover: { scale: 1.08 },
  tap: { scale: 0.99 },
};

function AnimateWrap({ size, children }) {
  const isSmall = size === 'small';
  const isLarge = size === 'large';

  return (
    <m.div
      whileTap="tap"
      whileHover="hover"
      variants={(isSmall && varSmall) || (isLarge && varLarge) || varMedium}
      className="inline-flex"
    >
      {children}
    </m.div>
  );
}
